<template>
  <div class="classify">
    <van-swipe :autoplay="3000" indicator-color="white" class="swiper-container">
      <van-swipe-item v-for="(item,index) in goods_pic_list" :key="index">
        <img :src="item" @click="clickImg(index)" />
      </van-swipe-item>
    </van-swipe>
    <!-- 改成轮播滑动商品 -->
    <div v-for="(data, type) in data_list" :key="data.cate_name" class="wrap">
      <van-swipe v-if="data.cate_name == '生活用品'" id="middle-banner-container">
        <van-swipe-item>
          <img :src="`${ossUrl}banner3.png`" />
        </van-swipe-item>
      </van-swipe>

      <div
        :class="data.cate_name == '生活用品' ? 'special-classify-list-container classify-list-container' : 'classify-list-container'"
      >
        <van-loading
          size="24px"
          vertical
          v-if="data.content.length == 0"
          style="position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);"
        >加载中...</van-loading>
        <header :key="flag">
          <div class="left-box">
            <h3 class="subtitle-text">{{data.title}}</h3>
            <p>{{data.subtitle}}</p>
          </div>
          <div class="right-box" v-for="(item, index) in data.content" :key="index">
            <span class="current-page">{{data.current_page}}</span>
            <span class="total-page">/{{data.content.length}}</span>
          </div>
        </header>
        <van-swipe
          class="van-swipe"
          @change="index => onChange(index, data)"
          :show-indicators="false"
        >
          <van-swipe-item class="van-swipe-item" v-for="(item, index) in data.content" :key="index">
            <div class="item-container" v-for="items in item" :key="items.good_id" v-if="items">
              <div class="good-item" v-on:click="toDetail(items)">
                <div class="good-pic-box">
                  <van-image
                    fit="scale-down"
                    :src="items.goods_pic"
                    :class="items.cate_id == 13 ? 'img': ''"
                  />
                </div>
                <div
                  :class="items.good_id == ''? 'ad-good-name good-name' : 'good-name'"
                >{{items.goods_name}}</div>
                <div class="join-count" v-if="items.good_id == ''">{{items.sale_client_count}}</div>
                <div class="join-count" v-else>已有{{items.sale_client_count}}位团长上架</div>
                <div class="income" v-if="items.cate_id != 13">一件赚¥{{items.gain_amount}}</div>
                <div class="good-price" v-if="items.cate_id != 13">
                  ¥
                  <span>{{items.cost_price}}</span>
                </div>
                <div
                  :class="items.good_id == ''? 'ad-go-goodDetail-btn go-goodDetail-btn' : 'go-goodDetail-btn'"
                  v-if="items.cate_id == 13"
                >查看详情</div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <footer>
      <img :src="`${ossUrl}footer.png`" alt />
    </footer>
  </div>
</template>


<script>
import wx from "weixin-js-sdk";
import configUrl from "../config/config.js";

export default {
  mixins: [configUrl],
  name: "classify",
  data() {
    return {
      title_list: ["休闲零食", "酒水饮料", "美妆护肤", "生活用品", "虚拟商品"], // 5个标题
      subtitle_list: [
        "美食带动你的味蕾",
        "便捷简餐美味加速度",
        "精致闪耀完美出彩",
        "生活所需尽在这里",
        "想你所想推荐专属"
      ],
      data_list: [], //商品列表数据
      goods_pic_list: [
        "http://txm.oss-cn-beijing.aliyuncs.com/TXM_static_material_img_banner1.png",
        "http://txm.oss-cn-beijing.aliyuncs.com/TXM_static_material_img_banner2.png"
      ],
      tempList: [],
      flag: 1
    };
  },
  methods: {
    onChange(index, data) {
      this.data_list[this.data_list.indexOf(data)].current_page = index + 1;
      this.flag++;
    },
    loadAjax(type = -1) {
      // 不传 type 就是获取所有
      let url = this.getDomain() + "goods/get_list";
      let params = {
        page: 1,
        pagesize: 100
      };
      if (type === -1) {
        for (let index in this.title_list) {
          this.data_list.push({
            page: 1,
            showMore: false, // 更多按钮的显隐
            title: this.title_list[index],
            subtitle: this.subtitle_list[index],
            cate_name: this.title_list[index],
            content: [], // 列表数据
            loading: false, // 加载状态
            total_count: 0 // total_count
          });
        }
        this.data_list.forEach(item => {
          let tempList = [];
          tempList.push(item.content);
        });
      } else {
        params["page"] = this.data_list[type].page;
        params["cate_name"] = this.data_list[type].cate_name;
        this.data_list[type].loading = true;
      }
      this.$axios
        .post(url, params)
        .then(res => {
          if (type === -1) {
            let data_list = res.data.content.data_list;
            let total_count_list = res.data.content.total_count_list;
            for (let index in this.data_list) {
              this.data_list[index].content.push(...data_list[index]);
              this.data_list[index].page += 1;
              this.data_list[index].total_count = total_count_list[index];
              this.data_list[index].showMore =
                this.data_list[index].content.length <
                this.data_list[index].total_count;
              this.data_list[index].loading = false;
            }
          } else {
            let data = res.data.content.data;
            this.data_list[type].content.push(...data);
            this.data_list[type].page += 1;
            this.data_list[type].showMore =
              this.data_list[type].content.length <
              this.data_list[type].total_count;
            this.data_list[type].loading = false;
          }
          this.data_list.forEach(item => {
            let tempList = [];
            for (let i = 0; i < item.content.length / 3; i++) {
              let x = item.content[i * 3];
              let y = item.content[i * 3 + 1];
              let z = item.content[i * 3 + 2];
              tempList.push([x, y, z]);
            }
            item.current_page = 1;
            item.content = tempList;
          });
        })
        .catch(error => {});
    },
    clickImg(index) {
      if (index == 1) {
        this.$router.push({ path: `/certificate` });
      } else {
      }
    },
    toDetail(item) {
      // 跳转详情页
      if (item.cate_id == 13) {
        if (item.good_id == "") {
          return;
        } else {
          this.$router.push({
            name: `Virtualdetail`,
            query: {
              good_id: item.good_id,
              good_name: item.goods_name,
              good_pic: item.goods_pic,
            }
          });
        }
      } else {
        this.$router.push({
          name: `detail`,
          query: {
            good_id: item.good_id,
            good_name: item.goods_name
          }
        });
      }
    },

    wx_jssdk() {
      this.$axios
        .post(this.getDomain() + "wx/get_signature", {
          url: window.location.href
        })
        .then(function(response) {
          if (response.data.err_code === 0) {
            wx.config({
              debug: false,
              appId: "wxe10d406d3c94eded",
              timestamp: response.data.content.timestamp,
              nonceStr: response.data.content.noncestr,
              signature: response.data.content.signature,
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData"
              ]
            });
            wx.ready(function() {
              wx.updateAppMessageShareData({
                title: "团小蜜爆款低价好物平台",
                desc:
                  "戳此链接，优选心动好货，爆款呈现！一键上架到团小蜜，转发到群马上赚钱！",
                link: "https://wxtxm.zidouchat.com/classify/#/",
                imgUrl:
                  "http://txm.oss-cn-beijing.aliyuncs.com/TXM_static_material_img_share_img.png",
                success: function() {}
              });
              wx.updateTimelineShareData({
                title: "团小蜜爆款低价好物平台",
                desc:
                  "戳此链接，优选心动好货，爆款呈现！一键上架到团小蜜，转发到群马上赚钱！",
                link: "https://wxtxm.zidouchat.com/classify/#/",
                imgUrl:
                  "http://txm.oss-cn-beijing.aliyuncs.com/TXM_static_material_img_share_img.png",
                success: function() {}
              });
            });
          }
        });
    }
  },
  created() {
    let url = window.location.href;
    if (url.indexOf("good_name") > -1) {
    } else {
      document.title = "团小蜜";
    }
  },
  mounted() {
    this.wx_jssdk();
    this.loadAjax();
  }
};
</script>

<style scoped lang='scss'>
.classify {
  width: 100%;
  overflow: hidden;
  .swiper-container {
    width: 100%;
    height: 3.76rem;
    .van-swipe-item img {
      width: 100%;
      height: 3.76rem;
      text-align: center;
    }
  }
  #middle-banner-container {
    width: 100%;
    height: 4.22rem;
    min-height: 0;
    img {
      width: 100%;
      height: 4.22rem;
    }
  }
  .classify-list-container {
    background: red;
    position: relative;
    left: 0.16rem;
    top: -0.6rem;
    width: 7.18rem;
    height: auto;
    min-height: 5.66rem;
    box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.04);
    border-radius: 0.08rem;
    background: #fff;
    z-index: 2;
    padding: 0 0.16rem;
    margin-bottom: 0.32rem;
    header {
      display: flex;
      position: relative;
      padding: 0.26rem 0.16rem;
      margin: 0 auto;
      padding-left: 0.16rem;
      .left-box {
        display: flex;
        line-height: 0.4rem;
        .subtitle-text {
          font-size: 0.28rem;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
        }
        p {
          font-weight: 400;
          margin-left: 0.12rem;
          color: rgba(153, 153, 153, 1);
        }
      }
      .right-box {
        position: absolute;
        right: 0.16rem;
        line-height: 0.4rem;
        .current-page {
          font-size: 0.32rem;
          color: #000000;
        }
        .total-page {
          font-size: 0.24rem;
          color: #999;
        }
      }
    }
    .van-swipe {
      width: 7.18rem;
      height: auto;
      min-height: 4.77rem;
      .item-container {
        display: flex;
        margin-right: 0.16rem;
        .good-item {
          width: 2.18rem;
          height: auto;
          .good-pic-box {
            position: relative;
            width: 2.18rem;
            height: 2.18rem;
            background: rgba(255, 255, 255, 1);
            border-radius: 0.04rem;
            border: 0.02rem solid rgba(249, 249, 249, 1);
            .van-image {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 1.86rem;
              height: 1.86rem;
            }
            .img {
              width: 2.18rem;
              height: 2.18rem;
            }
          }
          .good-name {
            height: 0.68rem;
            font-size: 0.24rem;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.8);
            line-height: 0.34rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            margin: 0.16rem 0 0.08rem;
          }
          .join-count {
            font-size: 0.2rem;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 0.28rem;
          }
          .income {
            display: inline-block;
            max-width: 2rem;
            height: 0.32rem;
            padding: 0 0.12rem;
            border-radius: 0.04rem;
            border: 1px solid rgba(227, 33, 36, 1);
            font-size: 0.2rem;
            font-weight: 400;
            color: rgba(227, 33, 36, 1);
            line-height: 0.28rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 0.14rem;
          }
          .good-price {
            height: auto;
            font-weight: 500;
            color: rgba(227, 33, 36, 1);
            margin-top: 0.25rem;
            word-wrap: break-word;
            text-align: left;
            span {
              font-size: 0.28rem;
            }
          }
          .go-goodDetail-btn {
            width: 1.56rem;
            height: 0.48rem;
            line-height: 0.48rem;
            font-size: 0.24rem;
            font-weight: 400;
            background: rgba(227, 33, 36, 1);
            border-radius: 0.04rem;
            text-align: center;
            color: rgba(255, 255, 255, 1);
            margin: 0.7rem auto 0.32rem;
          }
          .ad-good-name {
            color: rgba(102, 102, 102, 1);
          }
          .ad-go-goodDetail-btn {
            background: rgba(222, 222, 222, 1);
            color: rgba(153, 153, 153, 1);
          }
        }
      }
      .item-container:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .wrap:nth-child(n + 4) .classify-list-container {
    margin-bottom: 0;
  }
  .wrap:nth-child(5) {
    margin-top: -0.18rem;
  }
  .special-classify-list-container {
    top: -0.9rem;
  }
  footer {
    width: 100%;
    text-align: center;
    padding-bottom: 0.32rem;
    img {
      width: 5.96rem;
      height: 0.3rem;
    }
  }
}
</style>
<style>
.van-swipe__indicators {
  bottom: 0.78rem;
}
.van-swipe__indicator {
  width: 0.2rem;
  height: 0.08rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.05rem;
  opacity: 0.7;
}
.van-swipe__indicator--active {
  opacity: 1;
}
.van-swipe-item {
  display: flex;
}
</style>
